module.exports = __webpack_public_path__ + "static/assets/17c87f84cd427b624fad0fe085015075.png";